import type { GetFamilyIfManyTagsParams } from './types';
import { log } from '@/utils/logger';

/**
 * Validates input parameters for the getFamilyIfManyTags function
 *
 * @param params - Parameters to validate
 * @throws Error if validation fails (development mode only)
 * @remarks In production mode, validation errors are logged as warnings instead of throwing
 */
export function validateGetFamilyIfManyTagsParams(params: GetFamilyIfManyTagsParams): void {
  const { tagsSubset, allTags } = params;

  const handleValidationError = (message: string, invalidValue: unknown) => {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(message);
    } else {
      log.warning({
        event: 'tags_validation_failed',
        message,
        labels: {
          module: 'tags/validators',
          function: 'validateGetFamilyIfManyTagsParams',
        },
        stringify: {
          invalidValue,
          params,
        },
      });
    }
  };

  if (!Array.isArray(tagsSubset)) {
    handleValidationError('tagsSubset must be an array', tagsSubset);
  }

  if (!Array.isArray(allTags)) {
    handleValidationError('allTags must be an array', allTags);
  }

  if (Array.isArray(tagsSubset) && tagsSubset.length === 0) {
    handleValidationError('tagsSubset cannot be empty', tagsSubset);
  }
}
